/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Target-aware MCP and tool usage totals
 */
export type ToolUsageTotals = {
  /**
   * Number of tool usage events a policy denied
   */
  blockedCount: number;
  /**
   * Fraction of all tool usage events a policy denied
   */
  blockedRate: number;
  /**
   * Total number of tool usage events
   */
  eventCount: number;
  /**
   * Number of failed tool usage events
   */
  failureCount: number;
  /**
   * Fraction of completed tool usage events that failed
   */
  failureRate: number;
  /**
   * Number of successful tool usage events
   */
  successCount: number;
  /**
   * Number of distinct usage targets observed
   */
  uniqueTargets: number;
  /**
   * Number of distinct tools observed
   */
  uniqueTools: number;
  /**
   * Number of distinct user identities observed
   */
  uniqueUsers: number;
};

/** @internal */
export const ToolUsageTotals$inboundSchema: z.ZodMiniType<
  ToolUsageTotals,
  unknown
> = z.pipe(
  z.object({
    blocked_count: z.int(),
    blocked_rate: z.number(),
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    unique_targets: z.int(),
    unique_tools: z.int(),
    unique_users: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "blocked_count": "blockedCount",
      "blocked_rate": "blockedRate",
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "unique_targets": "uniqueTargets",
      "unique_tools": "uniqueTools",
      "unique_users": "uniqueUsers",
    });
  }),
);

export function toolUsageTotalsFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageTotals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageTotals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageTotals' from JSON`,
  );
}
